import React from "react";

const SectionLabel = ({ children }) => (
  <h2 className="mb-4 text-xs font-medium uppercase tracking-[0.18em] text-zinc-500">
    {children}
  </h2>
);

export default SectionLabel;
